<template>
  <div class="d-flex tab-title">
    <b-tooltip
      v-if="title && tooltipTargetEl"
      :key="tooltipTargetKey"
      :target="tooltipTargetEl"
      :title="title"
      placement="left"
      triggers="hover"
      boundary="viewport"
      container="body"
      noninteractive
    />
    <template v-if="icon">
      <b-icon :icon="icon" />
    </template>
    <template v-else>
      <slot />
    </template>
  </div>
</template>

<script>
export default {
  name: 'TabTitle',

  props: {
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      tooltipTargetEl: null,
    };
  },

  computed: {
    tooltipTargetKey() {
      const el = this.tooltipTargetEl;
      return el ? `${this.title}-${el.tagName}` : this.title;
    },
  },

  mounted() {
    this.resolveTooltipTarget();
  },

  updated() {
    this.resolveTooltipTarget();
  },

  methods: {
    resolveTooltipTarget() {
      if (!this.$el) {
        this.tooltipTargetEl = null;
        return;
      }

      const parentEl = this.$el.parentElement;
      if (parentEl && parentEl.nodeType === Node.ELEMENT_NODE) {
        this.tooltipTargetEl = parentEl;
        return;
      }

      const parent = this.$parent;
      if (parent && parent.$el && parent.$el.nodeType === Node.ELEMENT_NODE) {
        this.tooltipTargetEl = parent.$el;
        return;
      }

      this.tooltipTargetEl = null;
    },
  },
};
</script>

<style scoped lang="scss">

</style>
